import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Row, Col, Form, Input, Button, Select, Empty, Space, Popconfirm, BackTop, Popover, Tooltip, Spin, Tabs, Radio, Modal, Table, message, Pagination } from 'antd'
import styles from './sales-overview.module.less'
import moment from 'moment'
import lodash,{get, set,cloneDeep} from 'lodash'
import DateChoose from '@/compenents/dateChoose'
import CommoditySalesTrend from './commoditychart'
import SupplierSalesTrend from './supplierchart'
import { ajaxApi } from '../../../server'
import {QuestionCircleOutlined} from '@ant-design/icons'
import {getCookieNew} from '@/public/utils'
import qs from 'querystring'
import common from '../../../public/common'
const Option = Select.Option
const TabPane = Tabs.TabPane
const SalesOverview = () => {
  const [loading, setLoading] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const [modalBtnLoading, setModalBtnLoading] = useState(false)
  const [categoryArr, setCategoryArr] = useState([])
  const [brandArr, setBrandArr] = useState([])
  const [saleDefaultValue, setSaleDefaultValue] = useState('thirty_days')
  const [paramData, setParamData] = useState({
    // sid: 762,
    sid: JSON.parse(getCookieNew('supplierinfo')).sid,
    brand_id: [],
    category: [],
    start_date: moment(moment().startOf('day').subtract(30, 'days')).format('YYYY-MM-DD'),
    end_date: moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD')
  })
  const [param, setParam] = useState({
    // sid: 762,
    sid: JSON.parse(getCookieNew('supplierinfo')).sid,
    brand_id: [],
    category: [],
    name_code: '',
    particle: 'item',
    page_index: 1,
    page_size: 10,
    start_date: moment(moment().startOf('day').subtract(30, 'days')).format('YYYY-MM-DD'),
    end_date: moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD')
  })

  const [moduleTitle, setModuleTitle] = useState('添加商品')
  const [visiable, setVisiable] = useState(false)
  const [tableData, setTableData] = useState([])
  const [ids, setIds] = useState([])
  const [selectDataArr, setSelectDataArr] = useState([])
  const [selectedRowKeysArr, setSelectedRowKeysArr] = useState([])
  const [rowsArr, setRowsArr] = useState([])
  const [supplierData, setSupplierData] = useState([])
  const [commodityData, setCommodityData] = useState([])
  const [total, setTotal] = useState(0)
  const [isClick, setIsClick] = useState(false)

  //
  useEffect(() => {
    getCategory()
    getBrand()
    getSupplierData()
  }, [])

  // 获取品牌
  const getBrand = async () => {
    const res = await ajaxApi({
      params: qs.stringify({ sid: JSON.parse(getCookieNew('supplierinfo')).sid }),
      // params: qs.stringify({ sid: 762 }),
      url: common.SapUrl+'saleStat/query-brands',
      // url: 'http://192.168.10.141:8120/saleStat/query-brands',
      ContentType: 'application/x-www-form-urlencoded'
    })
    // console.log(res)
    if (res.status === 200 && res.data.brand_list.length !== 0) {
      setBrandArr(res.data.brand_list)
    }
  }

  // 获取类别
  const getCategory = async () => {
    const res = await ajaxApi({
      params: qs.stringify({ sid: JSON.parse(getCookieNew('supplierinfo')).sid }),
      url: common.SapUrl + 'base/queryCategory',
      ContentType: 'application/x-www-form-urlencoded'
    })
    // console.log(res)
    if (res.status === 200 && res.data.category_list.length !== 0) {
      setCategoryArr(res.data.category_list)
    }
  }

  // 获取供应商列表
  const getQueryGoodList = async (value,needOpen) => {
    var params = cloneDeep(value || param)
    set(params,'start_date',get(params,'start_date')?moment(get(params,'start_date')).valueOf():null)
    set(params,'end_date',get(params,'end_date')?(moment(get(params,'end_date')).valueOf()+86399000):null)
    if (checkEndDateIsToday(params)) {
      return
    }
    if(needOpen){
      setVisiable(true)
    }
    setModalLoading(true)
    const res = await ajaxApi({
      params,
      url: common.SapUrl+'saleStat/queryGoodsListWithSaleNums'
    })
    setModalLoading(false)
    if (res.status === 200 && res.data) {
      if (res.data.data.length !== 0) {
        setTableData(res.data.data.good_list)
      } else {
        setTableData([])
      }
      setTotal(res.data.data.total_count)
    } else {
      setTotal(0)
      setTableData([])
    }
  }

  // 获取供应商总览折线图
  const getSupplierData = async (value) => {
    var params = value || paramData
    if (checkEndDateIsToday(params)) {
      return
    }
    setLoading(true)
    const res = await ajaxApi({
      params: value || paramData,
      url: common.SapUrl + 'saleStat/queryOverview'
    })
    setLoading(false)
    // console.log(res)
    if (res.status === 200 && res.data.line_list.length !== 0) {
      const supplierList = []
      res.data.line_list.forEach((item) => {
        item.sale_num_list.forEach((item2, index) => {
          supplierList.push({
            date: moment(item2.count_date).format('YYYY-MM-DD'),
            type: item.line_name,
            value: item2.sale_num,
            category: item.category_id,
            brand_id: item.brand_id
          })
        })
      })
      // console.log(supplierList)
      setSupplierData(supplierList)
    } else {
      setSupplierData([])
    }
  }

  // 重置按钮
  const handleReast = () => {
    var start_date = moment().startOf('day').subtract(30, 'days').format('YYYY-MM-DD')
    var end_date = moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD')
    setParamData({...paramData, brand_id: [], category: [], start_date: start_date, end_date: end_date})
    setSaleDefaultValue([moment(start_date).valueOf(), moment(end_date).valueOf()])
    setIsClick(true)
    getSupplierData({...paramData, brand_id: [], category: [], start_date: start_date, end_date: end_date})
  }

  const search=()=>{
    getSupplierData(paramData)
  }

  // 获取下拉框的值
  const handleSlectPublic = (e, name) => {
    if (name === 'category') {
      setParamData({...paramData, category: e})
      // getSupplierData({...paramData, category: e})
    } else {
      setParamData({...paramData, brand_id: e})
      // getSupplierData({...paramData, brand_id: e})
    }
  }

  // 弹框确定按钮
  const handleOk = async () => {
    const rowsArrClone = lodash.clone(rowsArr)
    let idsArr = []
    if (rowsArrClone.length !== 0) {
      rowsArrClone.forEach((item) => {
        idsArr.push(item.id)
      })
    } else {
      idsArr = []
    }
    setIds(idsArr)
    setSelectDataArr(rowsArrClone)
    if (idsArr.length !== 0) {
      setModalBtnLoading(true)
      getCommodityData(idsArr)
    } else {
      message.warning('请选择商品或者货品', 1.5)
    }
  }

  const checkEndDateIsToday=(params)=>{
    var startOverflag = get(params, 'start_date') && (moment().subtract(1, 'days').endOf('day').valueOf() < moment(get(params, 'start_date')).valueOf())
    var endOverflag = get(params, 'end_date') && (moment().subtract(1, 'days').endOf('day').valueOf() < moment(get(params, 'end_date')).valueOf())
    if(startOverflag||endOverflag){
      message.error('不支持查询今天及之后的数据，请重新选择统计期间！')
    }
    return startOverflag||endOverflag
  }

  //  获取商品销量趋势折线图
  const getCommodityData = async (value) => {
    let params = {
      sid: JSON.parse(getCookieNew('supplierinfo')).sid,
      // sid: 762,
      id_list: value || ids,
      particle: param.particle,
      start_date: param.start_date,
      end_date: param.end_date
    }
    if (checkEndDateIsToday(params)) {
      return
    }
    setLoading(true)
    const res = await ajaxApi({
      params: params,
      url: common.SapUrl + 'saleStat/queryGoodsLine'
    })
    setLoading(false)
    setModalBtnLoading(false)
    if (res.status === 200 && res.data.line_list.length !== 0) {
      setVisiable(false)
      const commodityList = []
      res.data.line_list.forEach((item) => {
        item.sale_num_list.forEach((item2, index) => {
          commodityList.push({
            date: moment(item2.count_date).format('YYYY-MM-DD'),
            type: item.name,
            value: item2.sale_num
          })
        })
      })
      setCommodityData(commodityList)
      // setParamData({...paramData, category: [], brand_id: []})
      // getSupplierData({...paramData, category: [], brand_id: []})
    } else {
      setVisiable(false)
      setCommodityData([])
    }
  }

  // 弹框消失
  const handleCancel = () => {
    setVisiable(false)
    setSelectedRowKeysArr([])
    setRowsArr([])
    // setCommodityData([])
  }

  // 弹框查询
  const handleModuleSearch = () => {
    getQueryGoodList(param)
  }

  // 获取销售时间
  const SalesTime = (dataStr, type) => {
    let paramNew = lodash.cloneDeep(paramData)
    var start_date = dataStr.length !== 0?moment(dataStr[0]).format('YYYY-MM-DD'):''
    var end_date = dataStr.length !== 0?moment(dataStr[1]).format('YYYY-MM-DD'):''
    paramNew.start_date = start_date
    paramNew.end_date = end_date
    if(type === 'top'){
      setParamData({...paramData, start_date:start_date, end_date:end_date, page_index: 1})
    }else{
      setParam({...param, start_date:start_date, end_date:end_date, page_index: 1})
    }
    if (type === 'top') {
      // getSupplierData(paramNew)
    } else {
      if (ids.length !== 0) {
        getCommodityData(ids)
      }
    }
  }

  // 添加商品或者货品
  const handleAdd = async () => {
    if (param.particle === '') {
      message.warning('请选择商品或者货品！', 1.5)
    } else {
      if (param.particle === 'item') {
        setModuleTitle('添加商品')
      } else {
        setModuleTitle('添加货品')
      }
      setSelectedRowKeysArr([])
      setRowsArr([])
      await getQueryGoodList({...param, category: paramData.category, brand_id: paramData.brand_id },true)
      setParam({...param, category: paramData.category, brand_id: paramData.brand_id })
    }
  }

  // 删除
  const handleDelete = (id) => {
    let selecteDataArrNew = selectDataArr.filter((item) => item.id !== id)
    let idsNew = ids.filter((item) => item !== id)
    setSelectDataArr(selecteDataArrNew)
    setIds(idsNew)
    if (ids.length !== 0) {
      getCommodityData(ids)
    } else {
      setCommodityData([])
    }
  }

  // 清空
  const handleEmpty = () => {
    setSelectDataArr([])
    setIds([])
    setCommodityData([])
  }

  // 商品货品名称截取10位
  const dataConversion = (name) => {
    if (name) {
      if (name && name.length > 10) {
        return name.substring(0, 10) + '...'
      } else {
        return name
      }
    } else {
      return ''
    }
  }

  // 勾选
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeysArr(selectedRowKeys)
      setRowsArr(selectedRows)
    }
  }

  // 跳页数
  const onShowSizeChange = (current, pageSize) => {
    getQueryGoodList({ ...param, page_index: current, page_size: pageSize })
    setParam({ ...param, page_index: current, page_size: pageSize })
  }

  // 分页
  const pageChage = (page) => {
    getQueryGoodList({...param, page_index: page})
    setParam({ ...param, page_index: page })
  }

  const columns = [
    {
      title: '编码',
      dataIndex: 'code',
      width:150,
      renser: (_, record) => <span>{record.code || '--'}</span>
    },
    {
      title: '名称',
      dataIndex: 'name',
      renser: (_, record) => <span>{record.name || '--'}</span>
    },
    {
      title: '品牌',
      dataIndex: 'brand_name',
      width:120,
      renser: (_, record) => <span>{record.brand_name || '--'}</span>
    },
    {
      title: '类别',
      dataIndex: 'category_name',
      width:120,
      renser: (_, record) => <span>{record.category_name || '--'}</span>
    }
  ]

  return (
    <Spin spinning={loading}>
      <div className="goodIn">

        <div className="search">
          <Row gutter={24}>
            <Col span={5}>
              <span className={styles.publicspan}>商品类别：</span>
              <Select
                showSearch
                mode="multiple"
                allowClear={true}
                // onKeyDown={this.onKeyup}
                style={{ width: '75%', marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={paramData.category}
                onChange={(e) => handleSlectPublic(e, 'category')}
              >
                {(categoryArr || categoryArr.length === 0) ? categoryArr.map((item, index) => (
                  <Option key={index + 1} name='category' value={item.category_id}>{item.category_name}</Option>
                )) : null}
              </Select>
            </Col>

            <Col span={5}>
              <span className={styles.publicspan} style={{width: '82px'}}>商品品牌：</span>
              <Select
                showSearch
                mode="multiple"
                allowClear={true}
                // onKeyDown={this.onKeyup}
                style={{ width: '75%', marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={paramData.brand_id}
                onChange={(e) => handleSlectPublic(e, 'brand_id')}
              >
                {brandArr || brandArr.length === 0 ? brandArr.map((item, index) => (
                  <Option key={index + 1} name='brand_id' value={item.brand_id}>{item.brand_name}</Option>
                )) : null}
              </Select>
            </Col>
            <Col span={10}>
              <span className={styles.publicspan}>统计日期：</span>
              <DateChoose
                defaultValue={saleDefaultValue}
                ifConvenient={true}
                isStatus={true}
                isClick={false}
                ifshowClear={true}
                timerChange = {(data) => SalesTime(data, 'top')}
                endNotBeToday={true}
                time = {true}/>
            </Col>

            <Col span={3}>
              <Button type="primary" onClick={search} style={{marginRight:'6px'}}>查询</Button>
              {/* <Button onClick={handleReast}>重置</Button> */}
              <Button onClick={()=>{window.location.reload()}}>重置</Button>
            </Col>
          </Row>

        </div>
        <span>{supplierData.length !== 0 ? <div className="goodBody">
          <div className={styles.trend_title}><span>销量趋势</span> <Tooltip title="只能查询到当日前一天的数据"><QuestionCircleOutlined /></Tooltip></div>
          <SupplierSalesTrend supplierData={supplierData}></SupplierSalesTrend>
        </div> : <div className="goodBody" style={{textAlign: 'center', fontSize: '24px'}}><Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>}</span>

        <div className="goodBody">
          <Row gutter={24} style={{marginTop: '16px'}}>
            <Col span={24}>
              <Radio.Group style={{float: 'left'}} value={param.particle} onChange={(e) => { setParam({...param, particle: e.target.value}) }}>
                <Radio name='type' value={'item'}>商品</Radio>
                <Radio name='type' value={'product'}>货品</Radio>
              </Radio.Group>
              <span>
                <Space style={{display: 'flex', flexWrap: 'wrap', maxWidth: '78%', float: 'left',marginBottom:20}}>
                  {selectDataArr.length !== 0 ? selectDataArr.map((item, index) => {
                    return (
                      <span key = {index} className={styles.commodity_goods_style}>
                        <Tooltip title= {item.name}>
                          <span>{dataConversion(item.name)}</span>
                        </Tooltip>
                        <Popconfirm title="你确定要删除这条数据吗？" onConfirm={() => handleDelete(item.id)}>
                          <span style={{marginLeft: '8px', fontSize: '22px', cursor: 'pointer', display: 'none'}}>x</span>
                        </Popconfirm>
                        <span onClick={() => handleDelete(item.id)} style={{marginLeft: '8px', fontSize: '22px', cursor: 'pointer'}}>x</span>
                      </span>
                    )
                  }) : <span></span> }
                </Space>
              </span>
              <span style={{display: 'inline-block', marginTop: '-1%'}}>
                <Button style={{margin: '0px 8px'}} onClick={handleAdd} type='primary' shape="round">添加</Button>
                <a onClick={handleEmpty}>清空</a>
                <span style={{marginLeft:"24px"}}>
                  <span className={styles.publicspan}>统计日期：</span>
                  <DateChoose
                    defaultValue={saleDefaultValue}
                    ifConvenient={true}
                    isStatus={true}
                    isClick={false}
                    ifshowClear={true}
                    timerChange = {(data) => SalesTime(data, 'buttom')}
                    endNotBeToday={true}
                    time = {true}/>
                </span>
              </span>
              <div style={{clear: 'both'}}></div>
            </Col>
          </Row>
        </div>
        {commodityData.length !== 0 ? <div className="goodBody">
          <div className={styles.trend_title}><span>销量趋势</span> <Tooltip title="只能查询到当日前一天的数据"><QuestionCircleOutlined /></Tooltip></div>
          <CommoditySalesTrend commodityData = {commodityData} particle={param.particle}></CommoditySalesTrend>
        </div> : <div className="goodBody" style={{textAlign: 'center', fontSize: '24px'}}><Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>}

        <div>
          <Modal title={<span>{moduleTitle}
          <span style={{color:'orange',marginLeft:'20px',fontSize:14}}>只能添加统计期间内有销量的品!</span>
          </span>}
            visible={visiable}
            width={1000}
            onOk={handleOk}
            loading={modalLoading}
            onCancel={handleCancel}
            footer={[
              <Button key="back" onClick={handleCancel}>取消</Button>,
              <Button key="submit" type="primary" loading={modalBtnLoading} onClick={handleOk}>
                确定
              </Button>,
            ]}
            >
            <Row gutter={24}>
              <Col span={6} style={{display: param.particle === 'product' ? 'inline-block' : 'none'}}>
                <span className={styles.publicspan}>货品：</span>
                <Input
                  // onKeyDown={this.onKeyup}
                  placeholder='请输入' allowClear={true} name='name_code' onChange={(e) => { setParam({...param, name_code: e.target.value}) }} style={{ width: '70%', marginRight: '0px' }} />
              </Col>

              <Col span={6} style={{display: param.particle === 'item' ? 'inline-block' : 'none'}}>
                <span className={styles.publicspan}>商品：</span>
                <Input
                  // onKeyDown={this.onKeyup}
                  placeholder='请输入' allowClear={true} name='name_code' onChange={(e) => { setParam({...param, name_code: e.target.value}) }} style={{ width: '70%', marginRight: '0px' }} />
              </Col>

              <Col span={6}>
                <span className={styles.publicspan} style={{width: '82px'}}>品牌：</span>
                <Select
                  showSearch
                  mode="multiple"
                  allowClear={true}
                  // onKeyDown={this.onKeyup}
                  style={{ width: '70%', marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={param.brand_id}
                  onChange={(e) => { setParam({...param, brand_id: e}) }}
                >
                  <Option key={0} name='brand_id' value=''>请选择</Option>
                  {brandArr || brandArr.length === 0 ? brandArr.map((item, index) => (
                    <Option key={index + 1} name='brand_id' value={item.brand_id}>{item.brand_name}</Option>
                  )) : null}
                </Select>
              </Col>

              <Col span={6}>
                <span className={styles.publicspan}>类别：</span>
                <Select
                  showSearch
                  mode="multiple"
                  allowClear={true}
                  // onKeyDown={this.onKeyup}
                  style={{ width: '70%', marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={param.category}
                  onChange={(e) => { setParam({...param, category: e}) }}
                >
                  <Option key={0} name='category' value=''>请选择</Option>
                  {(categoryArr || categoryArr.length === 0) ? categoryArr.map((item, index) => (
                    <Option key={index + 1} name='category' value={item.category_id}>{item.category_name}</Option>
                  )) : null}
                </Select>
              </Col>

              <Col span={6}>
                <Button type='primary' onClick={handleModuleSearch}>查询</Button>
              </Col>
            </Row>

            <Spin spinning={modalLoading}>
              <Row gutter={24} style={{marginTop: '16px'}}>
                <Col span={24}>
                  <Table
                    bordered={false}
                    rowKey={record => record.id}
                    dataSource={tableData}
                    rowSelection={{...rowSelection, selectedRowKeys: selectedRowKeysArr}}
                    pagination={false}
                    columns={columns}
                    scroll={{y:450}}
                  >
                  </Table>
                  <div className={styles.page}>
                    <span style={{position: 'absolute', left: '2px', top: '-4px', fontSize: '14px'}}><span>共</span><span>{total}</span><span>条记录</span></span>
                    <Pagination current={param.page_index} showQuickJumper total={total} showSizeChanger onShowSizeChange={onShowSizeChange} onChange={pageChage}/>
                  </div>
                </Col>
              </Row>
            </Spin>
          </Modal>
        </div>
      </div>
      <BackTop visibilityHeight={50}></BackTop>
    </Spin>
  )
}
export default SalesOverview



// WEBPACK FOOTER //
// ./src/pages/salesreport/salesoverview/sales-overview.js